import { Component } from '@angular/core';

@Component({
    selector: 'kui-accordion',
    templateUrl: './accordion.component.html',
    standalone: false
})
export class KuiAccordionComponent { }
